import { useAuth0 } from '@auth0/auth0-react';
import CreateUser from '../../../pages/CreateUser';
import ForgotPasswordWrapper from '../../../pages/ForgotPassword';
import Login from '../../../pages/Login';
import ResetPasswordWrapper from '../../../pages/ResetPassword';
import React, { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';

export function Logout() {
  const { logout } = useAuth0();

  useEffect(() => {
    logout({ logoutParams: { returnTo: window.location.origin } });
  }, [logout]);

  return <div>Logging out...</div>;
}

export function HandleForwardURL(props: {
  Component: 'Login' | 'CreateUser' | 'ForgotPasswordParamHandler';
}) {
  const { invitationToken } = useParams<{ invitationToken?: string }>();
  let forwardUrl = window.location.search.split('forwardUrl=')[1];

  if (forwardUrl && !forwardUrl.match(/login$/)) {
    forwardUrl = decodeURIComponent(forwardUrl);
  }

  const componentProps: { forwardUrl?: string } = {};

  if (forwardUrl && !forwardUrl.match(/login$/)) {
    componentProps.forwardUrl = forwardUrl;
  }

  switch (props.Component) {
    case 'Login':
      return <Login {...componentProps} />;
    case 'CreateUser':
      return <CreateUser invitationToken={invitationToken ?? ''} {...componentProps} />;
    case 'ForgotPasswordParamHandler':
      return <ForgotPasswordParamHandler {...componentProps} />;
    default:
      return null;
  }
}

export function ResetPasswordCodeHandler() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const oobCode = queryParams.get('oobCode') as string;

  return <ResetPasswordWrapper code={oobCode} />;
}

export function ForgotPasswordParamHandler({ forwardUrl }: { forwardUrl?: string }) {
  const { email } = useParams<{ email?: string }>();
  return <ForgotPasswordWrapper email={email} forwardUrl={forwardUrl} />;
}
